@if (triggerForm()) {
  <div [formGroup]="triggerForm()" class="tw-flex tw-flex-col tw-gap-4">
    <!-- Attribute to compare -->
    <div class="tw-reset" #attributesField>
      <da-dropdown
        #attributeDropdown
        [config]="attributeDropdownConfig"
        [value]="attributeSelectionValues()"
        (selectionChange)="
          onAttributeSelect($event, attributeDropdown, attributeCombobox)
        "
      >
        <da-combobox
          #attributeCombobox
          [config]="attributeComboboxConfig"
          [selectionValues]="attributeDropdown.selectedItems()"
          (overlayChanges)="attributeDropdown.onSelectionUpdate($event)"
          (popoverClosing)="attributeDropdown.closePopover()"
        />
      </da-dropdown>
      @if (!attributeControl?.valid && triggerForm()?.touched) {
        <div role="alert" class="tw-mt-1 tw-text-sm tw-text-danger-800">
          {{ i18nShared.Core_FieldRequired }}
        </div>
      }
    </div>

    <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4">
      <!-- Starting Value -->
      <div class="tw-reset">
        @if (isAnyStartControl?.value) {
          <ng-container
            *ngTemplateOutlet="
              anyValuePlaceholder;
              context: {
                label: i18n.Automation_StartingAttributeValue,
                id: 'startingAttributeValue',
              }
            "
          ></ng-container>
        } @else {
          @switch (
            getAttributeType($safeNavigationMigration(attributeControl?.value))
          ) {
            @case (AttributeDataType.String) {
              <ng-container
                *ngTemplateOutlet="
                  textAttributeValue;
                  context: {
                    label: i18n.Automation_StartingAttributeValue,
                    id: 'startingAttributeValue',
                    type: 'text',
                  }
                "
              ></ng-container>
            }
            @case (AttributeDataType.Number) {
              <ng-container
                *ngTemplateOutlet="
                  textAttributeValue;
                  context: {
                    label: i18n.Automation_StartingAttributeValue,
                    id: 'startingAttributeValue',
                    type: 'number',
                  }
                "
              ></ng-container>
            }
            @case (AttributeDataType.DateTime) {
              <ng-container
                *ngTemplateOutlet="
                  dateAttributeValue;
                  context: {
                    label: i18n.Automation_StartingAttributeValue,
                    id: 'startingAttributeValue',
                  }
                "
              ></ng-container>
              @if (!startControl?.valid && triggerForm()?.touched) {
                <div role="alert" class="tw-mt-1 tw-text-sm tw-text-danger-800">
                  {{
                    errorMessageFor(
                      $safeNavigationMigration(startControl?.errors)
                    )
                  }}
                </div>
              }
            }
            @case (AttributeDataType.Bool) {
              <ng-container
                *ngTemplateOutlet="
                  booleanAttributeValue;
                  context: {
                    label: i18n.Automation_StartingAttributeValue,
                    id: 'startingAttributeValue',
                  }
                "
              ></ng-container>
              @if (!startControl?.valid && triggerForm()?.touched) {
                <div role="alert" class="tw-mt-1 tw-text-sm tw-text-danger-800">
                  {{
                    errorMessageFor(
                      $safeNavigationMigration(startControl?.errors)
                    )
                  }}
                </div>
              }
            }
          }
        }
        <div class="tw-mt-2">
          <input
            class="tw-checkbox tw-peer"
            type="checkbox"
            id="matchAnyStart"
            [formControl]="isAnyStartControl"
            data-dgat="trigger-attribute-changed-match-any-start"
          />
          <label
            class="tw-checkbox-label peer-checked:tw-checkbox-checked peer-disabled:tw-checkbox-disabled"
            for="matchAnyStart"
          >
            {{ i18n.Automation_MatchAnyStartingValue }}
          </label>
        </div>
      </div>

      <!-- Ending Value -->
      <div class="tw-reset">
        @if (isAnyEndControl?.value) {
          <ng-container
            *ngTemplateOutlet="
              anyValuePlaceholder;
              context: {
                label: i18n.Automation_EndingAttributeValue,
                id: 'endingAttributeValue',
              }
            "
          ></ng-container>
        } @else {
          @switch (
            getAttributeType($safeNavigationMigration(attributeControl?.value))
          ) {
            @case (AttributeDataType.String) {
              <ng-container
                *ngTemplateOutlet="
                  textAttributeValue;
                  context: {
                    label: i18n.Automation_EndingAttributeValue,
                    id: 'endingAttributeValue',
                    type: 'text',
                  }
                "
              ></ng-container>
            }
            @case (AttributeDataType.Number) {
              <ng-container
                *ngTemplateOutlet="
                  textAttributeValue;
                  context: {
                    label: i18n.Automation_EndingAttributeValue,
                    id: 'endingAttributeValue',
                    type: 'number',
                  }
                "
              ></ng-container>
            }
            @case (AttributeDataType.DateTime) {
              <ng-container
                *ngTemplateOutlet="
                  dateAttributeValue;
                  context: {
                    label: i18n.Automation_EndingAttributeValue,
                    id: 'endingAttributeValue',
                  }
                "
              ></ng-container>
              @if (!endControl?.valid && triggerForm()?.touched) {
                <div role="alert" class="tw-mt-1 tw-text-sm tw-text-danger-800">
                  {{
                    errorMessageFor(
                      $safeNavigationMigration(endControl?.errors)
                    )
                  }}
                </div>
              }
            }
            @case (AttributeDataType.Bool) {
              <ng-container
                *ngTemplateOutlet="
                  booleanAttributeValue;
                  context: {
                    label: i18n.Automation_EndingAttributeValue,
                    id: 'endingAttributeValue',
                  }
                "
              ></ng-container>
              @if (!endControl?.valid && triggerForm()?.touched) {
                <div role="alert" class="tw-mt-1 tw-text-sm tw-text-danger-800">
                  {{
                    errorMessageFor(
                      $safeNavigationMigration(endControl?.errors)
                    )
                  }}
                </div>
              }
            }
          }
        }
        <div class="tw-mt-2">
          <input
            class="tw-checkbox tw-peer"
            type="checkbox"
            id="matchAnyEnd"
            [formControl]="isAnyEndControl"
            data-dgat="trigger-attribute-changed-match-any-end"
          />
          <label
            class="tw-checkbox-label peer-checked:tw-checkbox-checked peer-disabled:tw-checkbox-disabled"
            for="matchAnyEnd"
          >
            {{ i18n.Automation_MatchAnyEndingValue }}
          </label>
        </div>
      </div>
    </div>

    @if (showInfoBanner()) {
      <div class="tw-reset">
        <da-alert theme="accent" [config]="{ title: infoBannerText() }" />
      </div>
    }
  </div>

  <dgx-trigger-back-cancel-save-buttons
    [i18n]="i18nShared"
    [isSaving]="isSaving()"
    (clearTrigger)="onBack()"
    (saveEmitter)="onSave()"
    (cancelEmitter)="onCancel()"
    (backEmitter)="onBack()"
  ></dgx-trigger-back-cancel-save-buttons>

  <!-- Simple string or number -->
  <ng-template
    #textAttributeValue
    let-label="label"
    let-id="id"
    let-type="type"
  >
    <da-input
      #inputElement
      [inputId]="id"
      [labelText]="label"
      [required]="true"
      [inputType]="type"
      [formControl]="
        id === 'startingAttributeValue' ? startControl : endControl
      "
      [errorOverrides]="
        triggerForm()?.touched &&
        !(id === 'startingAttributeValue'
          ? isAnyStartControl?.value
          : isAnyEndControl?.value)
          ? ((id === 'startingAttributeValue'
              ? startControl?.errors
              : endControl?.errors) ?? undefined)
          : undefined
      "
    />
  </ng-template>

  <!-- Wildcard placeholder: read-only da-input showing translated "Any value".
       Uses the SAME labelText as the value control it replaces so the label
       stays associated with the visible input and screen readers get the
       right announcement. -->
  <ng-template #anyValuePlaceholder let-label="label" let-id="id">
    <da-input
      [inputId]="id + '-any'"
      [labelText]="label"
      [readonly]="true"
      [formControl]="anyValueDisplayControl"
    />
  </ng-template>
  <!-- Static Date: parallel FormControl drives the display via CVA so
       Apollo's datepicker actually hydrates on edit. See
       getDateDisplayControl for the sync. -->
  <ng-template #dateAttributeValue let-label="label" let-id="id">
    <da-datepicker
      #datePicker
      [inputId]="id"
      [label]="label"
      [formControl]="
        getDateDisplayControl(id === 'startingAttributeValue' ? 'start' : 'end')
      "
    />
  </ng-template>
  <!-- Boolean -->
  <ng-template #booleanAttributeValue let-label="label" let-id="id">
    <div #selectComponent>
      <da-dropdown
        #booleanDropdown
        [config]="getBooleanDropdownConfig(id, label)"
        [value]="
          getBooleanSelectedItems(
            id === 'startingAttributeValue'
              ? $safeNavigationMigration(startControl?.value)
              : $safeNavigationMigration(endControl?.value)
          )
        "
        (selectionChange)="
          setBooleanValue(
            $event,
            id === 'startingAttributeValue',
            booleanDropdown,
            booleanSelectList
          )
        "
      >
        <da-select-list
          #booleanSelectList
          [config]="booleanSelectListConfig"
          [selectionValues]="booleanDropdown.selectedItems()"
          (overlayChanges)="booleanDropdown.onSelectionUpdate($event)"
          (popoverClosing)="booleanDropdown.closePopover()"
        />
      </da-dropdown>
    </div>
  </ng-template>
}
